export const DUPLICATE_ITEM_TITLE = _TL_('{{originalTitle}} - Copy');
